export default __webpack_public_path__ + "static/paper-38d273a2c817e08102c62e1e0d72118e.png";